import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, styled, Typography, Tooltip, IconButton } from '@mui/material';

import CommentSelect from './CommentSelect';
import TicketSearch from './TicketSearch';
import VariableList from './VariableList';
import { VariablesSidebarCollapsed } from './VariablesSidebarCollapsed';

const _Inputs = styled(Box)`
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export interface VariablesSidebarContentProps {
    collapsed?: boolean;
    onToggleCollapsed?: () => void;
}

export const VariablesSidebarContent = ({ collapsed = false, onToggleCollapsed }: VariablesSidebarContentProps) => {
    if (collapsed && onToggleCollapsed) {
        return <VariablesSidebarCollapsed onExpand={onToggleCollapsed} />;
    }

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                {onToggleCollapsed && (
                    <Tooltip title="Collapse variables panel">
                        <IconButton
                            data-qa="variablesSidebarCollapse"
                            aria-label="Collapse variables panel"
                            size="small"
                            onClick={onToggleCollapsed}
                            sx={{ flexShrink: 0 }}
                        >
                            <ChevronLeftIcon />
                        </IconButton>
                    </Tooltip>
                )}
                <Typography variant="h5" component="span" sx={{ flex: 1 }}>
                    Variables
                </Typography>
            </Box>
            <_Inputs>
                <TicketSearch />
                <CommentSelect />
            </_Inputs>
            <VariableList />
        </>
    );
};
